import React, { useState, useEffect, useRef } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Navbar, Nav, Button, Container, NavDropdown, Image, Modal } from 'react-bootstrap';
import { PersonCircle } from 'react-bootstrap-icons';
import 'boxicons/css/boxicons.min.css';

const customStyles = `
  @media (max-width: 991px) {
    .mobile-actions-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 0;
      border-top: 1px solid #e9ecef;
      margin-top: 10px;
    }
    .navbar-collapse .nav-menu {
      margin-bottom: 0;
    }
    .navbar-collapse .mobile-actions-row .btn {
      margin: 0 5px;
    }
    .navbar-collapse .mobile-actions-row .ls-notfication {
      margin: 0 5px;
    }
  }
  @media (min-width: 992px) {
    .mobile-actions-row {
      display: none;
    }
  }
  .notification-popover {
    position: fixed;
    max-width: 320px;
    width: 320px;
    z-index: 1050;
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 0.3rem;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  }
`;

const Header = () => {
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const notificationButtonRef = useRef(null);
  const [popoverPosition, setPopoverPosition] = useState({ top: 0, left: 0 });

  const [notifications] = useState({
    proposals: [
      { companyLogo: 'https://logo.clearbit.com/apple.com', companyName: 'Apple', message: 'New proposal received!' },
      { companyLogo: 'https://logo.clearbit.com/microsoft.com', companyName: 'Microsoft', message: 'Proposal under review.' }
    ],
    messages: [
      { companyLogo: 'https://logo.clearbit.com/amazon.com', companyName: 'Amazon', message: 'New message: "Let’s discuss further."' },
      { companyLogo: 'https://logo.clearbit.com/google.com', companyName: 'Google', message: 'Follow-up required on previous message.' }
    ],
    forum: [
      { companyLogo: 'https://logo.clearbit.com/tesla.com', companyName: 'Tesla', message: 'Someone liked your post!' },
      { companyLogo: 'https://logo.clearbit.com/netflix.com', companyName: 'Netflix', message: 'New comment on your topic.' }
    ]
  });

  const handleNotificationClick = () => {
    if (notificationButtonRef.current) {
      const rect = notificationButtonRef.current.getBoundingClientRect();
      const navbarHeight = document.querySelector('.navbar').offsetHeight; // Navbar height
      const buttonWidth = rect.width; // Width of the bell button
      const popoverWidth = 320; // Width of the popover
      const topPosition = rect.bottom + window.scrollY + 2; // 2px gap below the button
      const leftPosition = rect.left + window.scrollX + (buttonWidth / 2) - (popoverWidth / 2); // Center under the button
      
      // Ensure the popover stays within the viewport's left and right edges
      const viewportWidth = window.innerWidth;
      const adjustedLeft = Math.max(10, Math.min(leftPosition, viewportWidth - popoverWidth - 10)); // 10px padding from edges

      setPopoverPosition({ top: topPosition, left: adjustedLeft });
    }
    setShowNotifications(!showNotifications);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showNotifications &&
        !event.target.closest('.notification-popover') &&
        !event.target.closest('.ls-notfication')
      ) {
        setShowNotifications(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [showNotifications]);

  return (
    <>
      <style>{customStyles}</style>
      <Navbar expand="lg" className="py-3 fixed-top nav-bg">
        <Container>
          <Navbar.Brand as={Link} to="/" className="fs-3 fw-600 text-start">LeadStream</Navbar.Brand>
          <Navbar.Toggle aria-controls="navbarSupportedContent" />
          <Navbar.Collapse id="navbarSupportedContent">
            <Nav className="ms-3 nav-menu mb-2 mb-lg-0">
              <Nav.Item className="mx-0 text-decoration-none" as={NavLink} to="/ServicesList">
                <Button variant="btn-primary" className="mx-1 fw-500">Find Services</Button>
              </Nav.Item>
              <Nav.Item className="mx-0 text-decoration-none" as={NavLink} to="/ProductList">
                <Button variant="btn-primary" className="mx-1 fw-500">Find Products</Button>
              </Nav.Item>
              <Nav.Item className="mx-0 text-decoration-none" as={NavLink} to="/Get3Quotes">
                <Button variant="btn-primary" className="mx-1 fw-500">Get3Quotes</Button>
              </Nav.Item>
              <Nav.Item className="m-0 text-decoration-none" as={NavLink} to="/Forum">
                <Button variant="btn-primary" className="mx-1 fw-500">Forum</Button>
              </Nav.Item>
              <Nav.Item className="mx-0 text-decoration-none" as={NavLink} to="/writereview">
                <Button variant="btn-primary" className="mx-1 fw-500">Write a Review</Button>
              </Nav.Item>
            </Nav>

            {/* Mobile Actions Row */}
            <div className="mobile-actions-row">
              <Button
                variant="link"
                className="position-relative ls-notfication text-dark btn btn-link"
                ref={notificationButtonRef}
                onClick={handleNotificationClick}
              >
                <i className="bx bx-bell fs-4"></i>
                {(notifications.proposals.length + notifications.messages.length + notifications.forum.length) > 0 && (
                  <span className="position-absolute top-0 start-100 text-white translate-middle badge rounded-pill bg-danger">
                    {notifications.proposals.length + notifications.messages.length + notifications.forum.length}
                  </span>
                )}
              </Button>
              <NavLink to="/CreateCompanyProfileSearch" className="btn btn-primary btn-sm p-2 px-3">
                Create Company Profile
              </NavLink>
              <NavDropdown title={<PersonCircle size={30} />} id="profile-dropdown" align="end">
                <NavDropdown.Item as={Link} to="/MainDashboard">My Company Profiles</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/noncompanyprofile">My Proposals</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/MyShortList">My Shortlist</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/MyReviews">My Reviews</NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item as={Link} to="/Notification">Notifications</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/AccountSettings">Account Settings</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/LoginPage">Logout</NavDropdown.Item>
              </NavDropdown>
            </div>

            {/* Desktop Actions */}
            <Nav className="ms-auto mb-2 mb-lg-0 d-flex align-items-center d-none d-lg-flex">
              <Button
                variant="link"
                className="position-relative ls-notfication text-dark mt-2 mx-3 btn btn-link"
                ref={notificationButtonRef}
                onClick={handleNotificationClick}
              >
                <i className="bx bx-bell fs-4"></i>
                {(notifications.proposals.length + notifications.messages.length + notifications.forum.length) > 0 && (
                  <span className="position-absolute top-0 start-100 text-white translate-middle badge rounded-pill bg-danger">
                    {notifications.proposals.length + notifications.messages.length + notifications.forum.length}
                  </span>
                )}
              </Button>
              <NavLink to="/CreateCompanyProfileSearch" className="btn btn-primary btn-sm p-2 px-3 me-lg-4 me-2">
                Create Company Profile
              </NavLink>
              <NavDropdown title={<PersonCircle size={30} />} id="profile-dropdown" align="end">
                <NavDropdown.Item as={Link} to="/MainDashboard">My Company Profiles</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/noncompanyprofile">My Proposals</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/MyShortList">My Shortlist</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/MyReviews">My Reviews</NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item as={Link} to="/Notification">Notifications</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/AccountSettings">Account Settings</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/LoginPage">Logout</NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Notification Popover */}
      {showNotifications && (
        <div
          className="notification-popover"
          style={{ top: `${popoverPosition.top}px`, left: `${popoverPosition.left}px` }}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="p-3 bg-light border-bottom">
            <h3 className="m-0 fs-6 fw-semibold">Notifications</h3>
          </div>
          <div className="m-0 p-0">
            {Object.entries(notifications).map(([key, items]) => (
              <div key={key} className="mb-0">
                <div className="nt-header p-2 px-3 bg-light d-flex align-content-center border-bottom w-100 justify-content-between">
                  <h6 className="p-0 text-muted m-0">{key.charAt(0).toUpperCase() + key.slice(1)}</h6>
                  <Link to="/Notification" className="btn p-0 m-0 btn-sm small text-decoration-none btn-link">View All</Link>
                </div>
                <ul className="list-unstyled bg-white p-0 m-0">
                  {items.map((notif, index) => (
                    <li key={index} className="p-3 m-0 border-bottom d-flex align-items-center">
                      <Image src={notif.companyLogo} alt={notif.companyName} width={30} height={30} className="me-3 rounded-circle" />
                      <div>
                        <h6 className="p-0 m-0">{notif.companyName}</h6>
                        <p className="m-0 p-0 mt-1 small text-muted">{notif.message}</p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Floating Feedback Button */}
      <button
        className="btn btn-outline-primary bg-white text-primary position-fixed end-0 bottom-50 m-0 rotate_btn"
        onClick={() => setShowFeedbackModal(true)}
      >
        Feedback
      </button>

      {/* Feedback Modal */}
      <Modal show={showFeedbackModal} onHide={() => setShowFeedbackModal(false)} centered>
        <Modal.Header className="px-4" closeButton>
          <Modal.Title>Feedback Form</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <div className="mb-3">
            <label className="form-label">How would you rate our service?</label>
            <select className="form-select">
              <option value="">Select rating</option>
              <option value="5">⭐⭐⭐⭐⭐ - Excellent</option>
              <option value="4">⭐⭐⭐⭐ - Very Good</option>
              <option value="3">⭐⭐⭐ - Good</option>
              <option value="2">⭐⭐ - Fair</option>
              <option value="1">⭐ - Poor</option>
            </select>
          </div>
          <div className="mb-3">
            <label className="form-label">What can be improved?</label>
            <textarea className="form-control" rows="3" placeholder="Share your feedback..."></textarea>
          </div>
          <div className="mb-3">
            <label className="form-label">Your Name</label>
            <input type="text" className="form-control" placeholder="Enter your name" />
          </div>
          <div className="mb-3">
            <label className="form-label">Your Email Address</label>
            <input type="email" className="form-control" placeholder="Enter your email" />
          </div>
        </Modal.Body>
        <Modal.Footer className="px-4">
          <Button variant="secondary" onClick={() => setShowFeedbackModal(false)}>Close</Button>
          <Button variant="primary" onClick={() => setShowFeedbackModal(false)}>Submit</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Header;